import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Row, Col } from 'antd';
import Link from '../../Link';
import styles from './styles.less';
import { LocalizationContext } from '../../../hoc/Localization';
import { articleClicked } from '../../../utils/events/articles';

const Blog = ({ blog }) => {
  const { image, title, author, date: initialDate, excerpt } = blog;
  const { t, locale } = React.useContext(LocalizationContext);
  const date = moment(initialDate);

  return (
    <Row className={styles.container} type="flex" gutter={20}>
      <Col className={styles.imageCol} xs={24} md={12}>
        <div className={styles.imageContainer}>
          <img src={image} alt={title} />
        </div>
      </Col>
      <Col xs={24} md={12} className={styles.infoContainer}>
        <span className={styles.title}>{title}</span>
        <span className={styles.author}>{`${author.name} | ${date.format('DD MMM')}`}</span>
        <span className={styles.content} dangerouslySetInnerHTML={{ __html: excerpt }} />
        <div onClick={() => articleClicked(blog)}>
          <Link
            route="article"
            locale={locale}
            year={date.year()}
            month={date.month()}
            day={date.day()}
            url={blog.shortId}
          >
            <span className={styles.readMore}>{t('school.details.blog.read')}</span>
          </Link>
        </div>
      </Col>
    </Row>
  );
};

Blog.propTypes = {
  blog: PropTypes.object.isRequired,
};

export default Blog;
